import { Component, signal, viewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
    FormsModule,
    NgForm,
    ReactiveFormsModule,
    UntypedFormBuilder,
    UntypedFormGroup,
    Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { fuseAnimations } from '@fuse/animations';
import { TranslocoDirective } from '@jsverse/transloco';
import { AuthService } from 'app/core/auth/auth.service';
import { catchError, finalize } from 'rxjs';
import { ForgotPasswordDto } from '../../../../core/auth/auth.types';
import { BrandsService } from '../../../../core/brands/brands.service';
import { FidelityBasePageComponent } from '../../../../shared/components/fidelity-base-page/fidelity-base-page.component';
import { FidelityOverlayPageWrapperComponent } from '../../../../shared/components/fidelity-overlay-page-wrapper/fidelity-overlay-page-wrapper.component';
import { TbDismissableErrorComponent } from '../../../../shared/components/tb-dismissable-error/tb-dismissable-error.component';

@Component({
    selector: 'forgot-password',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        FidelityOverlayPageWrapperComponent,
        TranslocoDirective,
        TbDismissableErrorComponent,
    ],
    templateUrl: './forgot-password.component.html',
    styleUrl: './forgot-password.component.scss',
    animations: fuseAnimations,
})
export class ForgotPasswordPageComponent extends FidelityBasePageComponent {
    forgotPasswordNgForm = viewChild<NgForm>('forgotPasswordNgForm');
    availablePages = {};
    forgotPasswordForm: UntypedFormGroup;
    isLoading = signal(false);

    /**
     * Constructor
     */
    constructor(
        protected brandsService: BrandsService,
        private _authService: AuthService,
        private _formBuilder: UntypedFormBuilder
    ) {
        super();

        // Create the form
        this.forgotPasswordForm = this._formBuilder.group({
            email: ['', [Validators.required, Validators.email]],
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Send the reset link
     */
    sendResetLink(): void {
        if (this.forgotPasswordForm.invalid) {
            return;
        }

        this.isLoading.set(true);
        this.forgotPasswordForm.disable();

        const dto: ForgotPasswordDto = this.forgotPasswordForm.value;
        this._authService
            .forgotPassword(dto)
            .pipe(
                takeUntilDestroyed(this.destroyRef),
                finalize(() => {
                    this.isLoading.set(false);
                    this.forgotPasswordForm.enable();
                    this.forgotPasswordNgForm().resetForm();
                }),
                catchError(this.handlePageError.bind(this))
            )
            .subscribe(() => this.notifyResult(this.translocoService.translate('forgot-password.forgot-pwd-success')));
    }
}
